module.exports = __webpack_public_path__ + "static/media/susie-square.34e3be8d.jpg";